function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from "prop-types";
import React from "react";
export var OidcProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OidcProvider, _React$Component);

  function OidcProvider(props) {
    var _this;

    _classCallCheck(this, OidcProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OidcProvider).call(this, props));
    _this.history = props.history;
    _this.userManager = props.userManager;

    _this.userManager.events.addUserLoaded(function (user) {
      window.localStorage.setItem("accessToken", user.access_token);

      _this.props.onSignin(user);
    });

    _this.userManager.events.addSilentRenewError(_this.props.onError);

    _this.userManager.events.addAccessTokenExpiring(function () {
      _this.userManager.signinSilent()["catch"](function () {
        return _this.userManager.getUser().then(function (user) {
          if (!user || user.expired) {
            _this.signinSilent();
          } else {
            window.localStorage.setItem("accessToken", user.access_token);
          }
        })["catch"](_this.props.onError);
      });
    });

    _this.userManager.events.addUserSignedOut(function () {
      _this.userManager.removeUser().then(function () {
        location.href = "".concat(_this.props.config.authority, "?ReturnUrl=").concat(window.location.href);
      });
    });

    return _this;
  }

  _createClass(OidcProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (window.location.pathname === "/callback") {
        this.userManager.signinRedirectCallback().then(function (oidcUser) {
          localStorage.setItem("accessToken", oidcUser.access_token);

          if (_this2.history && _this2.history.push) {
            _this2.history.push(oidcUser.state.redirectURL || "/");
          } else {
            window.location.replace(oidcUser.state.redirectURL || "/");
          }
        })["catch"](function (err) {
          _this2.props.onError(err);

          window.location = "/";
        });
      } else if (window.location.pathname === "/silent-renew") {
        this.userManager.signinSilentCallback()["catch"](function (err) {
          _this2.props.onError(err);
        });
      } else {
        this.signinSilent();
      }
    }
  }, {
    key: "signinSilent",
    value: function signinSilent() {
      var _this3 = this;

      this.userManager.signinSilent()["catch"](function (err) {
        _this3.props.onError(err);

        _this3.userManager.signinRedirect({
          state: {
            redirectURL: window.location.pathname + window.location.search
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.props.children);
    }
  }]);

  return OidcProvider;
}(React.Component);
OidcProvider.propTypes = {
  userManager: PropTypes.object.isRequired,
  onError: PropTypes.func,
  onSignin: PropTypes.func,
  config: PropTypes.object,
  history: PropTypes.object
};
OidcProvider.defaultProps = {
  onError: function onError() {},
  onSignin: function onSignin() {}
};
export default OidcProvider;